module.exports = __webpack_public_path__ + "img/data-server-5.b6b7f37.png";